// useFetch.js
//
//  AM 2/26.
//
//  Abstract: Custom hook for fetch() to avoid axios

// import auth from "../../../functions/util/auth";

export default function useFetch() {

    //  Normally passed as parameter
    const baseUrl = 'https://us-central1-allergi-portal.cloudfunctions.net/api';

    //  HTTP GET
    // function get(url) {
    //     return fetch(baseUrl + url).then(response => response.json());
    // }

    // Authenticated HTTP GET
    function get(url, authToken = '') {
        return fetch((baseUrl + url), {
            mode: 'cors',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authToken,
            }
        })
        .then( response => response.json());
    }

    //  HTTP POST
    function post(url, body) {
        return fetch((baseUrl + url), {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json());
    }

    //  HTTP PUT (update)
    function put(url, body) {
        return fetch((baseUrl + url), {
            mode: 'cors',
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json());
    }

    return { get, post, put };
}
